module.exports = __webpack_public_path__ + "static/Becca-3ee9ba3bb835916e70435adeb2efeff8.png";